function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb2f2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb2f2"] = parcelRequire;
}
parcelRequire.register("gdr0J", function(module, exports) {

$parcel$export(module.exports, "default", () => $bce2d00733a79246$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $4LmDH = parcelRequire("4LmDH");
function $bce2d00733a79246$export$2e2bcd8739ae039(argument) {
    (0, $4LmDH.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $fSwVM.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRequire.register("fSwVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f57191916382d3$export$2e2bcd8739ae039);
function $b8f57191916382d3$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(obj);
}

});

parcelRequire.register("4LmDH", function(module, exports) {

$parcel$export(module.exports, "default", () => $377d1ce359384586$export$2e2bcd8739ae039);
function $377d1ce359384586$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

});


const $c6eb75a52ae267ba$export$9c206ddddb32a9b = document.querySelector(".section__header--paragraph--js");
$c6eb75a52ae267ba$export$9c206ddddb32a9b.innerHTML = "Ten tekst widzisz dzięki JS.";
$c6eb75a52ae267ba$export$9c206ddddb32a9b.style.color = "red";



var $gdr0J = parcelRequire("gdr0J");
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $6eb366e006a8b659$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}



var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $9445ecc5e7cfb647$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $4LmDH = parcelRequire("4LmDH");
var $f8bd67cac91ee19b$var$MILLISECONDS_IN_DAY = 86400000;
function $f8bd67cac91ee19b$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var startOfDayLeft = (0, $9445ecc5e7cfb647$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $9445ecc5e7cfb647$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $6eb366e006a8b659$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $6eb366e006a8b659$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $f8bd67cac91ee19b$var$MILLISECONDS_IN_DAY);
}



var $4LmDH = parcelRequire("4LmDH");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $5e650688c0910592$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $5e650688c0910592$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    var sign = $5e650688c0910592$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $f8bd67cac91ee19b$export$2e2bcd8739ae039)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($5e650688c0910592$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}




var $4LmDH = parcelRequire("4LmDH");
var $c83d105896c1098b$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $c83d105896c1098b$var$defaultRoundingMethod = "trunc";
function $c83d105896c1098b$export$b6474a47258c1211(method) {
    return method ? $c83d105896c1098b$var$roundingMap[method] : $c83d105896c1098b$var$roundingMap[$c83d105896c1098b$var$defaultRoundingMethod];
}


function $dfaafc43dccafd3d$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $4LmDH.default)(2, arguments);
    var diff = (0, $5e650688c0910592$export$2e2bcd8739ae039)(dateLeft, dateRight) / 7;
    return (0, $c83d105896c1098b$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}


function $2188fdc5cc474e7d$export$419478032e27d913(numberA, numberB) {
    return numberA - numberB;
}


for(let i = 0; i < 3; i++)console.log(`${i + 1} wykonanie pętli`);
let $5c9f23837bf5a870$var$myNumber = 13;
const $5c9f23837bf5a870$var$myFunction = (a)=>{
    const b = a * 3;
    const c = b * 7;
    return b * c;
};
const $5c9f23837bf5a870$var$elements = [
    "❤",
    "\uD83D\uDE0A",
    "\uD83D\uDE0D",
    "\uD83C\uDF80"
];
for(let i = 0; i < $5c9f23837bf5a870$var$elements.length; i++){
    $5c9f23837bf5a870$var$myNumber = $5c9f23837bf5a870$var$myNumber * (i + 1);
    console.log(`Index ${i} Emoji: ${$5c9f23837bf5a870$var$elements[i]}`);
    $5c9f23837bf5a870$var$myFunction(i);
}
let $5c9f23837bf5a870$var$n = 3;
while($5c9f23837bf5a870$var$n <= 9){
    console.log($5c9f23837bf5a870$var$n);
    $5c9f23837bf5a870$var$n = $5c9f23837bf5a870$var$n + 3;
}


const $ddfccdf02d97cfb8$var$arrayOne = [
    5,
    10,
    15,
    20,
    25,
    30,
    35
];
const $ddfccdf02d97cfb8$var$arrayTwo = [
    5,
    10,
    15,
    20,
    25
];
const $ddfccdf02d97cfb8$var$arrayThree = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
function $ddfccdf02d97cfb8$var$myFunction(numbers) {
    let sumArray = 0;
    for(i = 0; i < numbers.length; i++)sumArray = sumArray + numbers[i];
    return sumArray;
}
console.log("Wynik sumowania tablicy: " + $ddfccdf02d97cfb8$var$myFunction($ddfccdf02d97cfb8$var$arrayOne));
console.log("Wynik sumowania tablicy: " + $ddfccdf02d97cfb8$var$myFunction($ddfccdf02d97cfb8$var$arrayTwo));
console.log("Wynik sumowania tablicy: " + $ddfccdf02d97cfb8$var$myFunction($ddfccdf02d97cfb8$var$arrayThree));


console.log((0, $2188fdc5cc474e7d$export$419478032e27d913)(14, 4));
console.log("Hej! Fajnie, że tu zaglądasz.");
const $54b47fc030b7b21e$var$firstName = "Monika";
const $54b47fc030b7b21e$var$age = 35;
console.log(`Nazywam się ${$54b47fc030b7b21e$var$firstName} i mam ${$54b47fc030b7b21e$var$age} lat`);
function $54b47fc030b7b21e$var$person(name, age, town, hobby) {
    console.log(`Mam na imię ${name} i mam ${age} lata.`);
    console.log(`Moje miasto to ${town}, lubię ${hobby}.`);
}
$54b47fc030b7b21e$var$person("Monika", 34, "Kielce", "spotkania z przyjaci\xf3łmi");
$54b47fc030b7b21e$var$person("Hubert", 33, "Kielce", "karate");
$54b47fc030b7b21e$var$person("Liliana", 4, "Kielce", "Ju-jitsu");
$54b47fc030b7b21e$var$person("Aniela", 2, "Kielce", "plac zabaw");
const $54b47fc030b7b21e$var$resultDays = (0, $5e650688c0910592$export$2e2bcd8739ae039)(new Date(2023, 9, 10, 18, 0), new Date());
console.log(`Za ${$54b47fc030b7b21e$var$resultDays} dni będą moje urodziny`);
const $54b47fc030b7b21e$var$resultLiveDays = (0, $5e650688c0910592$export$2e2bcd8739ae039)(new Date(), new Date(1988, 10, 10));
const $54b47fc030b7b21e$var$resultWeeks = (0, $dfaafc43dccafd3d$export$2e2bcd8739ae039)(new Date(), new Date(1988, 10, 10));
console.log(`Jestem na tym świecie od ${$54b47fc030b7b21e$var$resultWeeks} tygodni a ${$54b47fc030b7b21e$var$resultLiveDays} dni`);


//# sourceMappingURL=index.70767976.js.map
